var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21701_151620)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_21701_151620)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6957 21.6667C13.0255 21.6667 13.35 21.7125 13.6693 21.7819C12.7333 23.1003 12.174 24.7163 12.174 26.4667C12.174 26.6544 12.2115 26.8325 12.27 27H8.52175C8.2327 27 8 26.7611 8 26.4667C8 23.8203 10.1058 21.6667 12.6957 21.6667ZM27.3043 21.6667C29.8932 21.6667 32 23.8203 32 26.4667C32 26.7611 31.7663 27 31.4783 27H27.73C27.7885 26.8325 27.826 26.6544 27.826 26.4667C27.826 24.7163 27.2667 23.1003 26.3307 21.7819C26.65 21.7125 26.9745 21.6667 27.3043 21.6667ZM19.9998 19.5333C23.7397 19.5333 26.7825 22.6437 26.7825 26.4667C26.7825 26.7284 26.5979 26.9462 26.3545 26.9914L26.2608 27H13.7389C13.4509 27 13.2171 26.7611 13.2171 26.4667C13.2171 22.6437 16.26 19.5333 19.9998 19.5333ZM27.3043 15.2667C28.7433 15.2667 29.913 16.4635 29.913 17.9333C29.913 19.4032 28.7433 20.6 27.3043 20.6C25.8653 20.6 24.6956 19.4032 24.6956 17.9333C24.6956 16.4635 25.8653 15.2667 27.3043 15.2667ZM12.7693 15.2667C14.2072 15.2667 15.378 16.4635 15.378 17.9333C15.378 19.4032 14.2072 20.6 12.7693 20.6C11.3313 20.6 10.1606 19.4032 10.1606 17.9333C10.1606 16.4635 11.3313 15.2667 12.7693 15.2667ZM19.9998 11C22.0138 11 23.6521 12.6747 23.6521 14.7333C23.6521 16.792 22.0138 18.4667 19.9998 18.4667C17.9859 18.4667 16.3476 16.792 16.3476 14.7333C16.3476 12.6747 17.9859 11 19.9998 11Z",
    fill: "#4251DA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21701_151620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_21701_151620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white",
    transform: "translate(8 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users-icon.edacbf01d10b3b7d1ecc39a59b9d7818.svg";
export { ForwardRef as ReactComponent };